import { Box, Field, Input, InputGroup, Text } from '@chakra-ui/react';
import { ReactNode, useRef } from 'react';

export interface CustomTextFieldProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  width?: string;
  maxWidth?: string;
  isDisabled?: boolean;
  label?: string;
  required?: boolean;
  type?: string;
  caption?: string;
  name?: string;
  rightElement?: ReactNode;
  errorText?: string;
  maxLength?: number;
}

const CustomTextField = ({
  value,
  onChange,
  placeholder = 'Enter value',
  isDisabled = false,
  label,
  required = false,
  type = 'text',
  caption,
  name,
  rightElement,
  errorText,
  maxLength,
}: CustomTextFieldProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <Field.Root required={required} width="100%" invalid={!!errorText}>
      {label && (
        <Field.Label
          fontSize={14}
          fontWeight={600}
          color={isDisabled ? 'fg.subtle' : 'bg.default'}
          mb={2}
        >
          {label}
          {!isDisabled && <Field.RequiredIndicator color="red.fg" />}
        </Field.Label>
      )}
      <Box position="relative" width="100%" ref={containerRef}>
        <InputGroup>
          <Input
            name={name}
            w="100%"
            variant="flushed"
            placeholder={placeholder}
            value={value || ''}
            onChange={handleChange}
            cursor={isDisabled ? 'not-allowed' : 'text'}
            disabled={isDisabled}
            required={required}
            type={type}
            maxLength={maxLength}
            paddingRight={rightElement ? '50px' : undefined}
          />
        </InputGroup>
        {caption && (
          <Box
            position="absolute"
            right="0"
            top="50%"
            transform="translateY(-50%)"
            pointerEvents="none"
            zIndex={1}
            px={2}
          >
            <Text
              fontSize="14px"
              color="fg.subtle"
              fontStyle="normal"
              fontWeight={400}
            >
              {caption}
            </Text>
          </Box>
        )}
        {rightElement && (
          <Box
            position="absolute"
            right="0"
            top="50%"
            transform="translateY(-50%)"
            zIndex={1}
          >
            {rightElement}
          </Box>
        )}
      </Box>
      {errorText && (
        <Field.ErrorText color="red.500" fontSize={12} mt={2} display="block">
          {errorText}
        </Field.ErrorText>
      )}
    </Field.Root>
  );
};

export default CustomTextField;
